import React from 'react';
import AutoCompleteInput from '../CommonComponents/AutoCompleteInput';

class InstitutionAutoCompleteView extends React.Component {
  componentDidMount() {
    const { setInstitutions, setTermQuery, value } = this.props;
    setInstitutions([]);
    if (value.label) {
      setTermQuery(value.label);
    } else {
      setTermQuery('');
    }
  }

  render() {
    const {
      institutions,
      fetchInstitutions,
      currentClient,
      onChange,
      querySelectorTerm,
      setTermQuery,
      ...restProps
    } = this.props;

    return (
      <AutoCompleteInput
        {...restProps}
        results={institutions}
        value={querySelectorTerm}
        onQueryChange={({ target: { value: term } }) => {
          setTermQuery(term);
          fetchInstitutions(currentClient.Id, term);
        }}
        onChange={result => {
          setTermQuery(result.label);
          onChange(result);
        }}
      />
    );
  }
}

export default InstitutionAutoCompleteView;
